import { render, staticRenderFns } from "./two_sided_multi_select.vue?vue&type=template&id=5a61965a&"
import script from "./two_sided_multi_select.vue?vue&type=script&lang=js&"
export * from "./two_sided_multi_select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/planorama/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a61965a')) {
      api.createRecord('5a61965a', component.options)
    } else {
      api.reload('5a61965a', component.options)
    }
    module.hot.accept("./two_sided_multi_select.vue?vue&type=template&id=5a61965a&", function () {
      api.rerender('5a61965a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/components/two_sided_multi_select.vue"
export default component.exports